import React, { useCallback, useRef, useState } from 'react';
import { Box, Flex } from 'rebass';
import Icon from '../Icon/Icon';
import useSize from '@react-hook/size';

interface AccordionProps {
  children?: React.ReactNode;
  title?: string;
  icon?: JSX.Element;
  variant?: 'onPane' | 'onMain'; // not first class variant usage
}

const Accordion = ({
  children,
  title,
  icon,
  variant = 'onPane',
}: AccordionProps): JSX.Element => {
  // Handle open/close
  const [expand, setExpand] = useState(true);
  // Ref
  const AccordionRef = useRef<HTMLElement>(null);
  const [width, height] = useSize(AccordionRef);

  const onClick = useCallback(
    (e: any) => {
      if (!e.target.matches('button, input, a, button *, a *')) {
        setExpand(!expand);
      }
    },
    [expand]
  );

  return (
    <Box
      sx={{
        position: 'relative',
        transition: 'all .2s linear',
      }}
      px={variant === 'onPane' ? 20 : 0}
    >
      {/* HEADER */}
      <Flex
        justifyContent="flex-start"
        alignItems="center"
        pt={5}
        pb={3}
        overflow="hidden"
        // bg="paneBg"
        bg={variant === 'onPane' ? 'paneBg' : 'background'}
        onClick={onClick}
        sx={{
          position: 'relative',
          zIndex: '2',
          '&:hover': {
            cursor: 'pointer',
          },
        }}
      >
        <Flex
          size={24}
          mr={1}
          alignItems="center"
          justifyContent="center"
          sx={{
            transition: 'all .2s linear',
            transform: !expand ? `rotate(-90deg)` : `rotate(0deg)`,
          }}
        >
          <Icon icon="chevron-down" size="16" />
        </Flex>
        <Box
          sx={{
            flexGrow: 1,
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
          }}
        >
          {title}
        </Box>
        {icon}
      </Flex>
      {/* Body */}
      <Box
        height={expand ? (height ? height : 'auto') : '0'}
        sx={{
          position: 'relative',
          overflow: 'hidden',
          transition: 'all .2s linear',
          transform: expand ? `translateY(0)` : `translateY(-100%)`,
        }}
      >
        <Box ref={AccordionRef}>{children}</Box>
      </Box>
    </Box>
  );
};

export default Accordion;
